import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin, Flex } from 'antd';
import useAuthStore from '../stores/authStore';
import { useHasPermission } from '../hooks/usePermissions';

interface ProtectedRouteProps {
  children: React.ReactElement;
  module?: string;
  action?: string;
}

/**
 * Wraps a route to enforce authentication and optional permission checks.
 *
 * - Unauthenticated → redirect to /connexion
 * - Loading auth state → spinner
 * - Authenticated but missing permission → /non-autorise
 * - Authenticated + permission OK → render children
 */
export default function ProtectedRoute({
  children,
  module,
  action,
}: ProtectedRouteProps): React.ReactElement {
  const { isAuthenticated, isLoading } = useAuthStore();
  const location = useLocation();
  const hasRequiredPermission = useHasPermission(module ?? '', action ?? '');

  if (isLoading) {
    return (
      <Flex justify="center" align="center" style={{ height: '100vh' }}>
        <Spin size="large" tip="Chargement…" />
      </Flex>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/connexion" state={{ from: location }} replace />;
  }

  if (module && action && !hasRequiredPermission) {
    return <Navigate to="/non-autorise" replace />;
  }

  return children;
}
